import loaderStore from 'components/ui/Loader/store';

/** Play a specific sound with fadein
*/
export const playSound = (id:string, duration = 2000, loop = false) => {
  const sound = loaderStore.getSound(id);
  
  if (sound) {
    sound.off();
    sound.play();
    sound.fade(0, .5, duration);

    //manual loop
    if(loop) {
      sound.once("end", () => {
        playSound(id, duration, true);
      });
    }
  }
}

/** Stop a specific sound with fade out
*/
export const stopSound = (id:string, duration = 1000) => {
  // mute the sound
  const sound = loaderStore.getSound(id);
  if (sound) {
    sound.off(); //clear existing events just ine case
    
    sound.fade(.5, 0, duration); //fade out
    sound.once("fade", () => {
      sound.stop(); //and stop
    });
  }
}
